/* eslint-disable max-len */
import { SEOPageWrapper } from '@/components/SEOPageWrapper';

import React, { useEffect, useState } from 'react';
import HeaderBar from '../desktop/HeaderBar';
// import CMSComponent from './CMS';
import { HeadingContent } from '@/slices/goyoloSeo/sliceType';
import { useAppSelector } from '@/utils/useGetBusRouteDataWithFilter';
import { Stack } from '@mui/material';
import { styled } from '@mui/system';
import { useRouter } from 'next/router';
import { pr } from '@/utils/pxToRem';
import { style } from '@/styles/globals';

const TitleContent = styled('div')`
  font-size: 1.5rem;
  font-weight: bold;
  vertical-align: bottom;
  display: inline-block;
`;

const ContentTableComponent = ({
  isDesktop, lang, tableContent,
}: any) => (
  <Stack sx={{
    padding: '32px 0',
  }}
  >
    <TitleContent>{lang?.tableContentMobile || 'Danh mục nội dung'}</TitleContent>
    <Stack
      sx={{
        marginTop: pr`16px`,
      }}
      spacing={pr`16px`}
    >
      {
              tableContent?.map((content: HeadingContent, idx: number) => (
                <a
                  style={{
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '20px',
                    textDecoration: 'none',
                    color: style.primary.blue,
                  }}
                  href={`#content_${content.idx}_${content.parentIdx}`}
                  key={content.id}
                >
                  <span>{`${idx + 1}. `}</span>
                  <span
                    style={{
                      textDecoration: 'underline',
                    }}
                    dangerouslySetInnerHTML={{ __html: content?.title }}
                  />
                </a>
              ))
            }
    </Stack>
  </Stack>
);
export default React.memo(ContentTableComponent);
